(function () {
  var MD_QUERY = '(min-width: 1025px)';
  var NARROW_CONTAINER_MAX = 1100;
  var MAGNIFICATION_SCALE_MIN = 2;

  function init(root) {
    if (root.dataset.megaMenuCategoryPanelInit) return;
    root.dataset.megaMenuCategoryPanelInit = '1';

    var tabs = Array.from(root.querySelectorAll('[data-mega-menu-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-mega-menu-panel]'));
    if (!tabs.length || !panels.length) return;

    var mql = window.matchMedia(MD_QUERY);
    var panelTitle = root.querySelector('[data-mega-menu-panel-title]');
    var panelBack = root.querySelector('.js-mega-menu-panel-back');

    function isMobile() {
      return !mql.matches;
    }

    function isMagnified() {
      var vv = window.visualViewport;
      return !!(vv && vv.scale >= MAGNIFICATION_SCALE_MIN);
    }

    function isMegaMenuNarrow() {
      return root.clientWidth <= NARROW_CONTAINER_MAX;
    }

    /**
     * Mobile, magnified (200%+), and narrow stacked layouts keep every tab in the
     * Tab order so keyboard users can reach each item without roving tabindex.
     */
    function usesFullTabOrder() {
      return isMobile() || isMagnified() || isMegaMenuNarrow();
    }

    function getSelectedTab() {
      return tabs.find(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      }) || tabs[0];
    }

    function syncTabTabindex(focusedTab) {
      if (usesFullTabOrder()) {
        tabs.forEach(function (tab) {
          tab.setAttribute('tabindex', '0');
        });
        return;
      }

      var active = focusedTab || getSelectedTab();
      tabs.forEach(function (tab) {
        tab.setAttribute('tabindex', tab === active ? '0' : '-1');
      });
    }

    function setPanelState(key) {
      panels.forEach(function (panel) {
        var selected = panel.dataset.megaMenuPanel === key;
        if (selected) {
          panel.removeAttribute('hidden');
          panel.setAttribute('tabindex', '0');
        } else {
          panel.setAttribute('hidden', '');
          panel.setAttribute('tabindex', '-1');
        }
      });
    }

    function activateTab(tab) {
      var key = tab.dataset.megaMenuTab;
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
      });
      setPanelState(key);
    }

    function updatePanelTitle(tab) {
      if (!panelTitle || !tab) return;
      var label = tab.querySelector('span');
      panelTitle.textContent = label ? label.textContent.trim() : '';
    }

    function openMobilePanel(tab) {
      root.classList.add('mega-menu--panel-open');
      activateTab(tab);
      updatePanelTitle(tab);
      tab.focus();
    }

    function closeMobilePanel() {
      root.classList.remove('mega-menu--panel-open');
      panels.forEach(function (panel) {
        panel.setAttribute('hidden', '');
        panel.setAttribute('tabindex', '-1');
      });
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
      });
      syncTabTabindex(tabs[0]);
    }

    function focusTab(tab) {
      syncTabTabindex(tab);
      tab.focus();
    }

    function moveFocus(step) {
      var idx = tabs.indexOf(document.activeElement);
      if (idx === -1) idx = tabs.indexOf(getSelectedTab());
      var next = (idx + step + tabs.length) % tabs.length;
      focusTab(tabs[next]);
    }

    function handleMobilePanelEscape(e) {
      if (e.key !== 'Escape' || !isMobile() || !root.classList.contains('mega-menu--panel-open')) return;
      e.preventDefault();
      e.stopPropagation();
      var activeTab = tabs.find(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      });
      closeMobilePanel();
      (activeTab || tabs[0]).focus();
    }

    if (panelBack) {
      panelBack.addEventListener('click', function (e) {
        e.preventDefault();
        var activeTab = tabs.find(function (t) {
          return t.getAttribute('aria-selected') === 'true';
        });
        closeMobilePanel();
        (activeTab || tabs[0]).focus();
      });
      panelBack.addEventListener('keydown', handleMobilePanelEscape);
    }

    panels.forEach(function (panel) {
      panel.addEventListener('keydown', handleMobilePanelEscape);
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        if (isMobile()) {
          openMobilePanel(tab);
        } else {
          activateTab(tab);
          focusTab(tab);
        }
      });

      tab.addEventListener('focus', function () {
        syncTabTabindex(tab);
      });

      tab.addEventListener('keydown', function (e) {
        var isDesktop = mql.matches;
        var next = -1;

        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          if (isMobile()) {
            openMobilePanel(tab);
          } else {
            activateTab(tab);
          }
          return;
        }

        if (isDesktop || !root.classList.contains('mega-menu--panel-open')) {
          if (e.key === 'ArrowDown') next = 1;
          else if (e.key === 'ArrowUp') next = -1;
        }

        if (e.key === 'Home') {
          e.preventDefault();
          focusTab(tabs[0]);
          return;
        }

        if (e.key === 'End') {
          e.preventDefault();
          focusTab(tabs[tabs.length - 1]);
          return;
        }

        if (e.key === 'Escape') {
          e.preventDefault();
          if (isMobile() && root.classList.contains('mega-menu--panel-open')) {
            handleMobilePanelEscape(e);
            return;
          }
          var mainMenu = root.closest('main-menu');
          if (mainMenu && typeof mainMenu.handleDocumentEscape === 'function') {
            mainMenu.handleDocumentEscape(e);
          } else {
            var details = root.closest('details');
            var summary = details && details.querySelector('summary');
            if (summary) summary.focus();
          }
          return;
        }

        if (next !== -1) {
          e.preventDefault();
          moveFocus(next);
        }
      });
    });

    function syncState() {
      if (isMobile()) {
        if (!root.classList.contains('mega-menu--panel-open')) {
          closeMobilePanel();
        } else {
          syncTabTabindex(getSelectedTab());
        }
      } else {
        root.classList.remove('mega-menu--panel-open');
        var selected = getSelectedTab();
        activateTab(selected);
        syncTabTabindex(selected);
      }
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', syncState);
    } else {
      mql.addListener(syncState);
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncState);
      window.visualViewport.addEventListener('scroll', syncState);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(syncState);
      resizeObserver.observe(root);
    }

    syncState();
  }

  function run() {
    document.querySelectorAll('[data-mega-menu-category-panel]:not([data-mega-menu-category-panel-init])').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();
